module.exports = new __parcel__URL__("GT-Pantheon_Animation_Spacing_Intra.58975fbd.json").toString();